<script>
  import { currentTab, switchTab } from '../stores/app.js'

  const tabs = [
    { id: 'workout', label: 'Workout', icon: '💪' },
    { id: 'overview', label: 'Overview', icon: '📊' },
    { id: 'database', label: 'Database', icon: '📝' }
  ]

  function handleTabClick(tabId) {
    switchTab(tabId)
  }
</script>

<nav class="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 safe-area-bottom">
  <div class="flex justify-around items-center h-20 max-md:pb-4">
    {#each tabs as tab}
      <button
        on:click={() => handleTabClick(tab.id)}
        class="flex flex-col items-center justify-center gap-x-2 flex-1 h-full min-w-0 transition-all"
        class:text-blue-600={$currentTab === tab.id}
        class:text-gray-600={$currentTab !== tab.id}
        aria-label={tab.label}
        aria-current={$currentTab === tab.id ? 'page' : undefined}
      >
        <span
          class="text-lg transition-all"
          class:grayscale={$currentTab !== tab.id}
          class:opacity-50={$currentTab !== tab.id}
        >
          {tab.icon}
        </span>
        <span class="text-xs font-medium">{tab.label}</span>
      </button>
    {/each}
  </div>
</nav>

<style>
  /* Ensure safe area for iOS devices */
  .safe-area-bottom {
    padding-bottom: env(safe-area-inset-bottom);
  }
</style>
